import React, { PureComponent } from 'react'
import classnames from 'classnames'

import { MarkerIcon } from './Icons'

import './Meeting.css'

export default class Meeting extends PureComponent {
  touched = code => e => {
    const { onChanged } = this.props
    onChanged(code)
  }

  render() {
    const {
      meeting: { code, /*languages, location,*/ name },
      selected
    } = this.props

    const meetingClasses = classnames('cm-meeting', {
      'cm-meeting__selected': selected
    })

    return (
      <button
        className={meetingClasses}
        id={`btn-meeting-${code}`}
        onClick={this.touched(code)}
      >
        <MarkerIcon className="cm-meeting--marker" />
        <div className="cm-meeting--infos">
          <div className="cm-meeting--name">{name}</div>
        </div>
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Meeting.js